function Header ({children}){

    return (
        <>
         {children}
        </>
    )
}

export default Header;